export enum StatusCode {
  UnknownError = 460,
  NetworkError = 461,
  Timeout = 408,
  SchemaParseError = 520,
}
